module.exports = __webpack_public_path__ + "static/img/ctjiedudiyiimg.93141cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctjiedudiyiimg.png
// module id = aEn9
// module chunks = 4